import React from 'react'
import TextField from 'material-ui/TextField'
import ScannedTextList from './ScannedTextList'

const LinField = ({
  linEmpty,
  lin,
  handleFieldChange,
  gotScannedText,
  handleScanned,
  scannedText
}) => {
  return (
    <div>
      {linEmpty && (
        <div>
          <TextField
            floatingLabelText="Lin"
            value={lin}
            onChange={handleFieldChange}
          />
          {gotScannedText && (
            <ScannedTextList
              handleChange={handleScanned}
              scannedText={scannedText}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default LinField



// WEBPACK FOOTER //
// ./src/components/LinField.js